import {instance} from "@/config/request.config";
import {TOKEN} from "@/constants";
import router from "@/router";
import { Preferences } from '@capacitor/preferences';
import { encryptData } from '@/utilities/crypto'

export function useRequest() {
    async function login(username, password) {
        try {
            const response = await instance.post("auth", {username, password});
            if (response) {
                localStorage.setItem(TOKEN, encryptData(response.data.data.token));
                localStorage.setItem('authUser', encryptData(response.data.data.loggedUser));
                localStorage.setItem('expirationLimit', encryptData(response.data.data.expiresAt));
                await Preferences.set({
                    key: 'authUser',
                    value: JSON.stringify(response.data.data.loggedUser)
                });
                await Preferences.set({
                    key: 'log_credentials',
                    value: JSON.stringify({username: username, password: password})
                });
                await Preferences.set({
                    key: 'expirationLimit',
                    value: JSON.stringify(response.data.data.expiresAt)
                });
                return response
            }
        }
        catch(error) {
            return error.response
        }
    }

    async function logout() {
        //TODO: request logout from BE from logout monitoring
        try {
            //localStorage.clear()
            removeLocalStorageItems()
            await router.push({ name: 'index' });
        } catch(error) {
            console.error("Something went wrong");
        }
    }

    function removeLocalStorageItems() {
        const keys = Object.keys(localStorage) ?? []

        keys.forEach(key => {
            if(key !== 'CapacitorStorage.log_credentials') localStorage.removeItem(key)
        })
    }

    return {
        login,
        logout
    }
}